// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__TeGxT","container":"main_container__Ycyn0","logoContainer":"main_logoContainer__oA9rR","loading":"main_loading__XqI72"};